import React from 'react';
interface KhatianDocumentProps {
  khatian: any;
}
export const KhatianDocument: React.FC<KhatianDocumentProps> = ({
  khatian
}) => {
  return <div className="bg-white p-8 border border-slate-300 shadow-sm max-w-4xl mx-auto font-bengali text-sm text-black" data-id="element-58">
      {/* Header */}
      <div className="flex justify-between items-start mb-6" data-id="element-59">
        <div className="flex-1 text-center" data-id="element-60">
          <h1 className="text-2xl font-bold" data-id="element-61">
            খতিয়ান নং- {khatian?.khatianNo || '৫৩৩৮'}
          </h1>
        </div>
        <div className="text-right" data-id="element-62">
          <p data-id="element-63">পৃষ্ঠা নংঃ ১</p>
        </div>
      </div>

      {/* Location Info */}
      <div className="flex justify-between border-b border-black pb-2 mb-2 text-sm font-medium" data-id="element-64">
        <div data-id="element-65">বিভাগঃ {khatian?.division || 'ঢাকা'}</div>
        <div data-id="element-66">জেলাঃ {khatian?.district || 'ঢাকা'}</div>
        <div data-id="element-67">উপজেলা/থানাঃ {khatian?.upazila || 'পল্লবী'}</div>
        <div data-id="element-68">মৌজাঃ {khatian?.mouja || 'উত্তর সেনপাড়া/পর্বতা'}</div>
        <div data-id="element-69">জে, এল, নংঃ {khatian?.jlNo || '০১১'}</div>
        <div data-id="element-70">রেঃ সাঃ নংঃ</div>
      </div>

      {/* Main Table */}
      <table className="w-full border-collapse border border-black text-xs text-center" data-id="element-71">
        <thead data-id="element-72">
          <tr data-id="element-73">
            <th className="border border-black p-1 w-1/4" rowSpan={2} data-id="element-74">
              মালিক, অকৃষি প্রজা বা ইজারাদারের
              <br data-id="element-75" />
              নাম ও ঠিকানা
            </th>
            <th className="border border-black p-1" rowSpan={2} data-id="element-76">
              অংশ
            </th>
            <th className="border border-black p-1" rowSpan={2} data-id="element-77">
              রাজস্ব
            </th>
            <th className="border border-black p-1" rowSpan={2} data-id="element-78">
              দাগ নং
            </th>
            <th className="border border-black p-1" colSpan={2} data-id="element-79">
              জমির শ্রেণি
            </th>
            <th className="border border-black p-1" colSpan={2} data-id="element-80">
              দাগের মোট
              <br data-id="element-81" />
              পরিমাণ
            </th>
            <th className="border border-black p-1" rowSpan={2} data-id="element-82">
              দাগের মধ্যে অত্র
              <br data-id="element-83" />
              খতিয়ানের অংশ
            </th>
            <th className="border border-black p-1" colSpan={2} data-id="element-84">
              অংশানুযায়ী জমির
              <br data-id="element-85" />
              পরিমাণ
            </th>
            <th className="border border-black p-1 w-1/6" rowSpan={2} data-id="element-86">
              দখল বিষয়ক বা অন্যান্য
              <br data-id="element-87" />
              বিশেষ মন্তব্য
            </th>
          </tr>
          <tr data-id="element-88">
            <th className="border border-black p-1" data-id="element-89">
              কৃষি
              <br data-id="element-90" />৫ (ক)
            </th>
            <th className="border border-black p-1" data-id="element-91">
              অকৃষি
              <br data-id="element-92" />
              ৫(খ)
            </th>
            <th className="border border-black p-1" data-id="element-93">
              একর
              <br data-id="element-94" />৬ (ক)
            </th>
            <th className="border border-black p-1" data-id="element-95">
              শতাংশ
              <br data-id="element-96" />৬ (খ)
            </th>
            <th className="border border-black p-1" data-id="element-97">
              একর
              <br data-id="element-98" />৮ (ক)
            </th>
            <th className="border border-black p-1" data-id="element-99">
              শতাংশ
              <br data-id="element-100" />৮ (খ)
            </th>
          </tr>
          <tr className="bg-slate-50" data-id="element-101">
            <th className="border border-black p-1" data-id="element-102">১</th>
            <th className="border border-black p-1" data-id="element-103">২</th>
            <th className="border border-black p-1" data-id="element-104">৩</th>
            <th className="border border-black p-1" data-id="element-105">৪</th>
            <th className="border border-black p-1" colSpan={2} data-id="element-106">
              ৫
            </th>
            <th className="border border-black p-1" colSpan={2} data-id="element-107">
              ৬
            </th>
            <th className="border border-black p-1" data-id="element-108">৭</th>
            <th className="border border-black p-1" colSpan={2} data-id="element-109">
              ৮
            </th>
            <th className="border border-black p-1" data-id="element-110">৯</th>
          </tr>
        </thead>
        <tbody data-id="element-111">
          <tr data-id="element-112">
            <td className="border border-black p-2 text-left align-top" data-id="element-113">
              <p className="font-bold underline mb-1" data-id="element-114">মালিক</p>
              <p data-id="element-115">{khatian?.ownerName || 'দং আবদুল জব্বার মিয়া'}</p>
              <p data-id="element-116">পিং {khatian?.fatherName || 'নুর মোহাম্মদ বাড়ী'}</p>
              <p className="mt-2" data-id="element-117">মিসেস নাজমে আরা জহুরা খাতুন</p>
              <p data-id="element-118">পিং রেজাউর রহমান খান</p>
              <p className="mt-2" data-id="element-119">ডাঃ ইসরাত জাহান ডলি</p>
              <p data-id="element-120">পিং মোঃ হাবিব উল্লা</p>
              <p className="mt-4" data-id="element-121">আরজুমান্দ বানু দেবী</p>
              <p data-id="element-122">পিং হাবিব উল্লা</p>
              <p data-id="element-123">বাড়ী নং ৪ রোড নং ৩৪</p>
              <p data-id="element-124">ব্লক ট, সেকশন ৬</p>
              <p data-id="element-125">থানা পল্লবী</p>
            </td>
            <td className="border border-black p-1 align-top" data-id="element-126">
              <p data-id="element-127">০.২৫০</p>
              <p className="mt-6" data-id="element-128">০.২৫০</p>
              <p className="mt-6" data-id="element-129">০.২৫০</p>
              <p className="mt-8" data-id="element-130">০.২৫০</p>
            </td>
            <td className="border border-black p-1 align-top" data-id="element-131"></td>
            <td className="border border-black p-1 align-top" data-id="element-132">১৯১৮৬</td>
            <td className="border border-black p-1 align-top" data-id="element-133"></td>
            <td className="border border-black p-1 align-top" data-id="element-134">বাড়ী</td>
            <td className="border border-black p-1 align-top" data-id="element-135"></td>
            <td className="border border-black p-1 align-top" data-id="element-136"></td>
            <td className="border border-black p-1 align-top" data-id="element-137">১.০০০</td>
            <td className="border border-black p-1 align-top" data-id="element-138"></td>
            <td className="border border-black p-1 align-top" data-id="element-139">০২৮০</td>
            <td className="border border-black p-1 align-top" data-id="element-140"></td>
          </tr>
          {/* Empty rows to fill space if needed, matching the image style */}
          <tr data-id="element-141">
            <td className="border border-black p-1 h-32" data-id="element-142"></td>
            <td className="border border-black p-1" data-id="element-143"></td>
            <td className="border border-black p-1" data-id="element-144"></td>
            <td className="border border-black p-1" data-id="element-145"></td>
            <td className="border border-black p-1" data-id="element-146"></td>
            <td className="border border-black p-1" data-id="element-147"></td>
            <td className="border border-black p-1" data-id="element-148"></td>
            <td className="border border-black p-1" data-id="element-149"></td>
            <td className="border border-black p-1" data-id="element-150"></td>
            <td className="border border-black p-1" data-id="element-151"></td>
            <td className="border border-black p-1" data-id="element-152"></td>
            <td className="border border-black p-1" data-id="element-153"></td>
          </tr>
          <tr data-id="element-154">
            <td className="border border-black p-1 text-left text-[10px]" data-id="element-155">
              ......... ধারামতে নোট বা পরিবর্তন{' '}
              <span className="font-bold" data-id="element-156">
                যার মোকদ্দমা নং......... এবং সন.........
              </span>
            </td>
            <td className="border border-black p-1 font-bold" data-id="element-157">১.০০০</td>
            <td className="border border-black p-1 col-span-6 text-right font-bold" colSpan={6} data-id="element-158">
              মোট জমিঃ
            </td>
            <td className="border border-black p-1" data-id="element-159"></td>
            <td className="border border-black p-1 font-bold" data-id="element-160">০</td>
            <td className="border border-black p-1 font-bold" data-id="element-161">২৮০</td>
            <td className="border border-black p-1" data-id="element-162"></td>
          </tr>
        </tbody>
      </table>

      {/* Footer */}
      <div className="flex justify-between items-end mt-6 text-xs" data-id="element-163">
        <div data-id="element-164">
          <p data-id="element-165">মুদ্রণঃ সেটেলমেন্ট প্রেস, ঢাকা। তারিখঃ ১৫-০৫-২০২৩</p>
          <p className="mt-4" data-id="element-166">বাংলাদেশ ফর্ম নং ৫৪৬২ (সংশোধিত)</p>
        </div>
        <div className="text-right flex flex-col items-end" data-id="element-167">
          <p className="mb-2" data-id="element-168">কম্পিউটার কোডঃ ৪৩০৫১৫১৬১০৩১০১১৬৬-০২০২৩৪৪</p>
          <div className="w-16 h-16 bg-slate-200 border border-slate-400 flex items-center justify-center" data-id="element-169">
            <span className="text-[8px] text-slate-500" data-id="element-170">QR Code</span>
          </div>
        </div>
      </div>
    </div>;
};